var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.792 16.16c-1.09 0-1.88-.497-2.094-1.286-.577.872-1.56 1.328-2.5 1.328-1.879 0-3.246-1.452-3.246-3.57 0-2.738 1.944-4.751 4.23-4.751.854 0 1.837.394 2.157 1.266l.192-.997h1.88l-1.132 5.147a2.68 2.68 0 0 0-.064.436c0 .415.192.788.726.788 1.132 0 2.2-1.66 2.2-3.714 0-2.968-2.328-5.105-5.767-5.105-3.674 0-6.409 2.573-6.409 6.433 0 3.528 2.457 6.184 6.601 6.184 1.431 0 2.884-.415 4.123-1.328l.961 1.266C16.454 19.336 14.318 20 12.566 20 7.567 20 4 16.846 4 12.135 4 7.3 7.781 4 12.352 4 16.71 4 20 6.905 20 10.786c0 3.134-1.987 5.354-4.208 5.375zm-1.923-4.772c0-1.1-.555-1.764-1.602-1.764-1.474 0-2.328 1.515-2.328 2.864 0 1.12.49 1.992 1.644 1.992 1.304 0 2.243-1.287 2.286-3.092z"}));
}

Email.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = Email;

Email.default = Email;
